// Re-present when the LIGHT changes — the sibling of the camera watch.
// Notes: ~/comments/aos-threejs-poc/lightWatch_nothing_re_presents.md

import { useMemo, useRef } from 'react'
import * as THREE from 'three'
import { useFrame, useThree } from '@react-three/fiber'
import { createLightWatch } from '../../ogs/pipeline/lightWatch.ts'

/** UI cadence: a person changes the light, and the poll costs one scene traversal. */
const POLL_MS = 100

/** Calls `onChanged` when the light the shade renders under has moved. */
export function useLightRelight({ active, avatar, onChanged }) {
  const scene = useThree((state) => state.scene)
  const watch = useMemo(() => createLightWatch(), [])
  const nextPoll = useRef(0)
  const world = useRef(new THREE.Vector3())
  // collectSceneLights INDEXES its `at`, so the Vector3 has to be spelled out.
  const at = useRef([0, 0, 0])

  useFrame(() => {
    if (!active()) return
    const now = performance.now()
    if (now < nextPoll.current) return
    nextPoll.current = now + POLL_MS
    // Where the probe volume samples its grid; a point light falls off with distance.
    const root = avatar()
    if (root) {
      root.getWorldPosition(world.current)
      at.current[0] = world.current.x
      at.current[1] = world.current.y
      at.current[2] = world.current.z
    }
    const probe = typeof window !== 'undefined' ? window.__LIGHT_PROBE__ : null
    if (watch.moved(scene, at.current, probe)) onChanged()
  })
}
